export const FormatDate = (value: string) => {
  if (value === null || value === undefined) {
    return ''
  } else {
    const date = new Date(value)
    return date.toLocaleDateString('en-GB')
  }
}
